var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cargo-advance-search fcl-search-bar",
      staticStyle: { height: "auto", width: "100%", "margin-top": "5px" }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSimple,
              expression: "showSimple"
            }
          ],
          staticClass: "cargo-advance-search-header"
        },
        [
          _c("div", { staticClass: "cargo-advance-search-toggle-trigger" }, [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAdv,
                  expression: "showAdv"
                }
              ],
              staticClass: "el-icon-arrow-left",
              style: {
                transform: !_vm.isShowingMoreSearchCondition
                  ? "rotate(-90deg)"
                  : "rotate(90deg)"
              },
              on: { click: _vm.upOrDownSearchCondition }
            })
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSimple && !_vm.isShowingMoreSearchCondition,
                  expression: "showSimple && !isShowingMoreSearchCondition"
                }
              ],
              staticClass: "cargo-advance-search-quick"
            },
            [
              _vm.showPriceNo
                ? _c("el-input", {
                    ref: "keyword",
                    staticStyle: { width: "200px" },
                    attrs: {
                      no: "priceNo",
                      placeholder: _vm.simQueryPlaceholder,
                      spellcheck: false
                    },
                    on: { blur: _vm.keyWordBlur },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.toQuery($event)
                      }
                    },
                    model: {
                      value: _vm.filter.priceNo,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "priceNo", $$v)
                      },
                      expression: "filter.priceNo"
                    }
                  })
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && _vm.showPriceNo
                ? _c("cargo-advance-select", {
                    staticStyle: { width: "115px", display: "inline-block" },
                    attrs: {
                      no: "currency",
                      filterable: "",
                      disabled: _vm.disabled,
                      clearable: false,
                      "select-type": _vm.selectTypeNames.basic_data_Currency,
                      "default-value": _vm.filter.currency
                    },
                    on: { parentCallBack: _vm.changeCurrency }
                  })
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && !_vm.showPriceNo
                ? _c("cargo-advance-select", {
                    ref: "simPol",
                    staticStyle: {
                      width: "190px",
                      display: "inline-block",
                      "margin-left": "10px"
                    },
                    attrs: {
                      no: "simPol",
                      filterable: "",
                      placeholder: _vm.$t("Pricing.POLPrompt"),
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      "custom-label": function(item) {
                        return "[" + item.code + "]" + item.englishName
                      },
                      "filter-tag-names": ["code", "englishName"],
                      "show-custom-label-in-option": true,
                      "default-value": _vm.filter.simPol
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.filter.simPol = p.value
                      }
                    }
                  })
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && !_vm.showPriceNo
                ? _c("cargo-advance-select", {
                    ref: "simPod",
                    staticStyle: {
                      width: "190px",
                      display: "inline-block",
                      "margin-left": "10px"
                    },
                    attrs: {
                      no: "simPod",
                      filterable: "",
                      placeholder: _vm.$t("Pricing.PODPrompt"),
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      "custom-label": function(item) {
                        return "[" + item.code + "]" + item.englishName
                      },
                      "filter-tag-names": ["code", "englishName"],
                      "show-custom-label-in-option": true,
                      "default-value": _vm.filter.simPod
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.filter.simPod = p.value
                      }
                    }
                  })
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && _vm.showLevel
                ? _c(
                    "el-select",
                    {
                      staticStyle: {
                        width: "90px",
                        display: "inline-block",
                        "margin-left": "10px"
                      },
                      attrs: { no: "level" },
                      on: { change: _vm.onLevelChanged },
                      model: {
                        value: _vm.filter.level,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "level", $$v)
                        },
                        expression: "filter.level"
                      }
                    },
                    _vm._l(_vm.tiers, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              ref: "searchOperations",
              staticClass: "cargo-advance-search-operations"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: {
                    no: "query",
                    type: "primary",
                    disabled: _vm.disabled
                  },
                  on: { click: _vm.toQuery }
                },
                [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "reset", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.resetSearch()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))]
              ),
              _vm._t("operations")
            ],
            2
          )
        ]
      ),
      _vm._t("searchAreaHeader"),
      _vm.showAdv
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowingMoreSearchCondition,
                  expression: "isShowingMoreSearchCondition"
                }
              ],
              staticClass: "section cargo-advance-search-more"
            },
            [
              _c("div", {
                staticClass: "cargo-advance-search-more-operations"
              }),
              _c(
                "el-form",
                {
                  ref: "hbDetail",
                  staticClass: "cargo-advance-search-form",
                  staticStyle: { "min-width": "830px", "margin-right": "10px" },
                  attrs: { "label-position": "left", inline: true }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "rdoGroupOrg" },
                      model: {
                        value: _vm.rdoGroupOrg,
                        callback: function($$v) {
                          _vm.rdoGroupOrg = $$v
                        },
                        expression: "rdoGroupOrg"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { no: "POL", label: "pol" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.POL")))
                      ]),
                      _c("el-radio", { attrs: { no: "POLs", label: "pols" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.POLs")))
                      ]),
                      _c("el-radio", { attrs: { no: "COL", label: "col" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.COL")))
                      ]),
                      _c("el-radio", { attrs: { no: "ROL", label: "rol" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.ROL")))
                      ]),
                      _c(
                        "el-radio",
                        { attrs: { no: "POLCity", label: "polCityCode" } },
                        [_vm._v(_vm._s(_vm.$t("Pricing.POLCity")))]
                      )
                    ],
                    1
                  ),
                  _vm.rdoGroupOrg === "pols"
                    ? _c("cargo-pop-select-input", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "pols",
                          "column-defs": _vm.popSelectInputCols,
                          "use-type": 2
                        },
                        model: {
                          value: _vm.filter.pols,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "pols", $$v)
                          },
                          expression: "filter.pols"
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupOrg === "pol"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "pol",
                          filterable: "",
                          placeholder: _vm.$t("Pricing.POLPrompt"),
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          "custom-label": function(item) {
                            return "[" + item.code + "]" + item.englishName
                          },
                          "filter-tag-names": ["code", "englishName"],
                          "show-custom-label-in-option": true,
                          "default-value": _vm.filter.pol
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.pol = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupOrg === "col"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "col",
                          filterable: "",
                          placeholder: _vm.$t("Pricing.COLPrompt"),
                          "select-type": _vm.selectTypeNames.basic_data_Country
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.col = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupOrg === "rol"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "rol",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          "default-value": _vm.filter.rol
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.rol = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupOrg === "polCityCode"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "polCityCode",
                          "static-options": _vm.citySeaport,
                          "tag-name": "name",
                          "tag-value": "code",
                          placeholder: _vm.$t("Pricing.POLCityPrompt"),
                          clearable: "",
                          filterable: "",
                          "filter-tag-names": ["name", "code"],
                          "default-value": _vm.filter.polCityCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.polCityCode = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _c(
                    "el-select",
                    {
                      staticStyle: {
                        width: "80px",
                        display: "inline-block",
                        "margin-left": "10px"
                      },
                      attrs: {
                        no: "cmbCreatedBy",
                        disabled: _vm.isShowCreatedBy
                      },
                      model: {
                        value: _vm.filter.cmbCreatedBy,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "cmbCreatedBy", $$v)
                        },
                        expression: "filter.cmbCreatedBy"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("Pricing.CreatedBy"),
                          value: "createdBy"
                        }
                      }),
                      _c("el-option", {
                        attrs: {
                          label: _vm.$t("Pricing.Branch"),
                          value: "branch"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.filter.cmbCreatedBy === "createdBy"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "282px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "createdBy",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "default-value": _vm.filter.createdBy,
                          "callback-params": { key: "userId" }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.createdBy = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.filter.cmbCreatedBy === "branch"
                    ? _c("cargo-office-select", {
                        staticStyle: {
                          width: "282px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "branch",
                          disabled: false,
                          "office-id": !_vm.filter.branch
                            ? 0
                            : _vm.filter.branch,
                          "default-value": _vm.filter.branch,
                          "tag-name": "code"
                        },
                        on: {
                          change: function(p) {
                            _vm.filter.branch = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.isManageModule
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hbDateCreatedFromTo",
                          attrs: { label: _vm.$t("Pricing.CreatedDate") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: {
                              width: "130px",
                              "margin-left": "10px"
                            },
                            attrs: {
                              no: "createDateFrom",
                              type: "date",
                              "picker-options": {
                                disabledDate: function(time) {
                                  return (
                                    time.getTime() >
                                    new Date(
                                      _vm.filter.createDateTo + " 23:59:59"
                                    ).getTime()
                                  )
                                }
                              },
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.createDateFrom,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "createDateFrom", $$v)
                              },
                              expression: "filter.createDateFrom"
                            }
                          }),
                          _c("span", { staticStyle: { margin: "5px" } }, [
                            _vm._v(_vm._s(_vm.$t("Pricing.EndDate")))
                          ]),
                          _c("el-date-picker", {
                            staticStyle: {
                              width: "130px",
                              "margin-left": "10px"
                            },
                            attrs: {
                              no: "createDateTo",
                              "picker-options": {
                                disabledDate: function(time) {
                                  return (
                                    time.getTime() <
                                    new Date(
                                      _vm.filter.createDateFrom + " 00:00:00"
                                    ).getTime()
                                  )
                                }
                              },
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.createDateTo,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "createDateTo", $$v)
                              },
                              expression: "filter.createDateTo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isShowSaleState
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hbSaleState",
                          attrs: {
                            "label-width": "80px",
                            label: _vm.$t("Pricing.SaleState")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "115px" },
                            attrs: {
                              no: "saleState",
                              filterable: "",
                              disabled: _vm.disabled,
                              clearable: false,
                              "default-value": _vm.filter.saleState,
                              headers: [_vm.$t("Price.Code")],
                              fields: ["code"],
                              "tag-name": "chineseName",
                              "tag-value": "code",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_SpecialPriceSaleState$SALE_STATE_TYPES_All
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.saleState = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isShowContractNo
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hbContractNo",
                          attrs: { label: _vm.$t("Pricing.ContractNo") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "85px" },
                            attrs: { no: "contractNo" },
                            model: {
                              value: _vm.filter.contractNo,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "contractNo", $$v)
                              },
                              expression: "filter.contractNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isSurcharge
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hbDangerous",
                          attrs: {
                            "label-width": "80px",
                            label: _vm.$t("Pricing.Dangerous")
                          }
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "dangerous" },
                            model: {
                              value: _vm.filter.dangerous,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "dangerous", $$v)
                              },
                              expression: "filter.dangerous"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isSurcharge && !_vm.isQuery
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hbBookingAgent",
                          attrs: { label: _vm.$t("Pricing.BookingAgent") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "190px" },
                            attrs: {
                              no: "bAgentAutoComplete",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { bookingAgent: true },
                              "custom-label": function(item) {
                                return "" + item.chineseName
                              },
                              "show-custom-label-in-option": true,
                              "tag-value": "cmpIdx"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.bAgentAutoComplete = p.cmpIdx
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isSurcharge && !_vm.isQuery
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hFeeName",
                          attrs: { label: _vm.$t("Pricing.FeeName") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "190px" },
                            attrs: {
                              no: "chargeScaleCode",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_ChargeItem,
                              "callback-method-type": "value",
                              "tag-name": "zhName",
                              "tag-value": "scaleCode"
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.chargeScaleCode = p
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showCurrency
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hbCurrency",
                          attrs: {
                            "label-width": "75px",
                            label: _vm.$t("Pricing.Currency")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "115px" },
                            attrs: {
                              no: "currency",
                              filterable: "",
                              disabled: _vm.disabled,
                              clearable: false,
                              "default-value": _vm.filter.currency,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency
                            },
                            on: { parentCallBack: _vm.changeCurrency }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "hbDetail2",
                  attrs: {
                    "label-width": "80px",
                    "label-position": "left",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "rdoGroupDes" },
                      model: {
                        value: _vm.rdoGroupDes,
                        callback: function($$v) {
                          _vm.rdoGroupDes = $$v
                        },
                        expression: "rdoGroupDes"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { no: "POD", label: "pod" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.POD")))
                      ]),
                      _c("el-radio", { attrs: { no: "PODs", label: "pods" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.PODs")))
                      ]),
                      _c("el-radio", { attrs: { no: "COD", label: "cod" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.COD")))
                      ]),
                      _c("el-radio", { attrs: { no: "ROD", label: "rod" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.ROD")))
                      ]),
                      _c(
                        "el-radio",
                        { attrs: { no: "PODCity", label: "podCityCode" } },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PODCity")))]
                      )
                    ],
                    1
                  ),
                  _vm.rdoGroupDes === "pod"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "pod",
                          filterable: "",
                          placeholder: _vm.$t("Pricing.PODPrompt"),
                          "select-type": _vm.selectTypeNames.basic_data_Seaport,
                          "custom-label": function(item) {
                            return "[" + item.code + "]" + item.englishName
                          },
                          "filter-tag-names": ["code", "englishName"],
                          "show-custom-label-in-option": true,
                          "default-value": _vm.filter.pod
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.pod = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupDes === "pods"
                    ? _c("cargo-pop-select-input", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "pods",
                          "column-defs": _vm.popSelectInputCols,
                          "use-type": 2
                        },
                        model: {
                          value: _vm.filter.pods,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "pods", $$v)
                          },
                          expression: "filter.pods"
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupDes === "cod"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "cod",
                          filterable: "",
                          placeholder: _vm.$t("Pricing.CODPrompt"),
                          "select-type": _vm.selectTypeNames.basic_data_Country,
                          "default-value": _vm.filter.cod
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.cod = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupDes === "rod"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "rod",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          "default-value": _vm.filter.rod
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.rod = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupDes === "podCityCode"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block"
                        },
                        attrs: {
                          no: "podCityCode",
                          "static-options": _vm.citySeaport,
                          "tag-name": "name",
                          "tag-value": "code",
                          clearable: "",
                          placeholder: _vm.$t("Pricing.PODCityPrompt"),
                          filterable: "",
                          "filter-tag-names": ["name", "code"],
                          "default-value": _vm.filter.podCityCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.podCityCode = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      ref: "hbCarrier",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { label: _vm.$t("Pricing.Carrier") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "carrier",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { seaCmp: true },
                          "custom-label": function(item) {
                            return "[" + item.shortName + "]" + item.chineseName
                          },
                          "show-custom-label-in-option": true,
                          multiple: "",
                          "default-multiple-value": _vm.filter.carrier
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.carrier = p.cmpIdx
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "hbSource",
                      attrs: { label: _vm.$t("Pricing.Source") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100px" },
                        attrs: { no: "txtBookingAgent" },
                        model: {
                          value: _vm.filter.txtBookingAgent,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "txtBookingAgent", $$v)
                          },
                          expression: "filter.txtBookingAgent"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "hbFromTo",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { label: _vm.$t("Pricing.BeginDate") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "130px", "margin-left": "10px" },
                        attrs: {
                          no: "beginDate",
                          type: "date",
                          "picker-options": {
                            disabledDate: function(time) {
                              return (
                                time.getTime() >
                                new Date(
                                  _vm.filter.endDate + " 23:59:59"
                                ).getTime()
                              )
                            }
                          },
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.filter.beginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "beginDate", $$v)
                          },
                          expression: "filter.beginDate"
                        }
                      }),
                      _c("span", { staticStyle: { margin: "5px" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.EndDate")))
                      ]),
                      _c("el-date-picker", {
                        staticStyle: { width: "130px" },
                        attrs: {
                          no: "endDate",
                          type: "date",
                          "picker-options": {
                            disabledDate: function(time) {
                              return (
                                time.getTime() <
                                new Date(
                                  _vm.filter.beginDate + " 00:00:00"
                                ).getTime()
                              )
                            }
                          },
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.filter.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "endDate", $$v)
                          },
                          expression: "filter.endDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.showLevel
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hbLevel",
                          attrs: { label: _vm.$t("Pricing.Level") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "100px",
                                display: "inline-block"
                              },
                              attrs: { no: "level" },
                              on: { change: _vm.onLevelChanged },
                              model: {
                                value: _vm.filter.level,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "level", $$v)
                                },
                                expression: "filter.level"
                              }
                            },
                            _vm._l(_vm.tiers, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isSurcharge
                    ? _c(
                        "el-form-item",
                        {
                          ref: "hbUnNo",
                          attrs: { label: _vm.$t("Pricing.UnNo") }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "85px" },
                            attrs: { no: "unNo" },
                            model: {
                              value: _vm.filter.unNo,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "unNo", $$v)
                              },
                              expression: "filter.unNo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showExpirationDate,
                          expression: "showExpirationDate"
                        }
                      ],
                      staticStyle: { "margin-left": "10px" },
                      attrs: { label: _vm.$t("Pricing.ExpirationDate") }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "130px", "margin-left": "10px" },
                        attrs: {
                          no: "expirationBeginDate",
                          type: "date",
                          "picker-options": {
                            disabledDate: function(time) {
                              return (
                                time.getTime() >
                                new Date(
                                  _vm.filter.expirationEndDate + " 23:59:59"
                                ).getTime()
                              )
                            }
                          },
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.filter.expirationBeginDate,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "expirationBeginDate", $$v)
                          },
                          expression: "filter.expirationBeginDate"
                        }
                      }),
                      _c("span", { staticStyle: { margin: "5px" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.EndDate")))
                      ]),
                      _c("el-date-picker", {
                        staticStyle: { width: "130px" },
                        attrs: {
                          no: "expirationEndDate",
                          type: "date",
                          "picker-options": {
                            disabledDate: function(time) {
                              return (
                                time.getTime() <
                                new Date(
                                  _vm.filter.expirationBeginDate + " 00:00:00"
                                ).getTime()
                              )
                            }
                          },
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.filter.expirationEndDate,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "expirationEndDate", $$v)
                          },
                          expression: "filter.expirationEndDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      ref: "hbCarrier",
                      staticStyle: { "margin-left": "10px" },
                      attrs: { label: _vm.$t("SeaExport.CargoType") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoType",
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoType,
                          headers: [_vm.$t("Partners.chineseName")],
                          fields: ["chineseName"],
                          "filter-field-names": ["chineseName"],
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.filter.cargoType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.cargoType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": "80px",
                    "label-position": "left",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Pricing.PriceType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          disabled: _vm.disabledFreightType,
                          no: "freightType",
                          "static-options": _vm.priceTypes,
                          "tag-value": "code",
                          "default-value": _vm.filter.freightType,
                          clearable: ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.freightType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.showSpotSearch
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "vessel",
                              "select-type":
                                _vm.selectTypeNames.static_data_Vessel,
                              cache: false,
                              filterable: "",
                              "allow-create": true,
                              "static-options": _vm.vesselList,
                              "default-value": _vm.filter.vessel
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.onVesselSelectionChange(p)
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.showSpotSearch
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                        [
                          _c("cargo-advance-select", {
                            ref: "voyageFlight",
                            attrs: {
                              no: "6",
                              "static-options": _vm.voyages || [],
                              cache: false,
                              "default-value": _vm.filter.voyageFlight,
                              filterable: "",
                              clearable: "",
                              "allow-create": true,
                              "tag-name": "voyageNo",
                              "tag-value": "voyageNo",
                              "filter-tag-names": ["voyageNo"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.voyageFlight = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.showSpotSearch
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: "ETD" }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: {
                              width: "130px",
                              "margin-left": "10px"
                            },
                            attrs: {
                              no: "beginEtd",
                              type: "date",
                              "picker-options": {
                                disabledDate: function(time) {
                                  return (
                                    time.getTime() >
                                    new Date(
                                      _vm.filter.endEtd + " 23:59:59"
                                    ).getTime()
                                  )
                                }
                              },
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.beginEtd,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "beginEtd", $$v)
                              },
                              expression: "filter.beginEtd"
                            }
                          }),
                          _c("span", { staticStyle: { margin: "5px" } }, [
                            _vm._v(_vm._s(_vm.$t("Pricing.EndDate")))
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              no: "endEtd",
                              type: "date",
                              "picker-options": {
                                disabledDate: function(time) {
                                  return (
                                    time.getTime() <
                                    new Date(
                                      _vm.filter.beginEtd + " 00:00:00"
                                    ).getTime()
                                  )
                                }
                              },
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.endEtd,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "endEtd", $$v)
                              },
                              expression: "filter.endEtd"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.showSpotSearch
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: "ETA" }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: {
                              width: "130px",
                              "margin-left": "10px"
                            },
                            attrs: {
                              no: "beginEta",
                              type: "date",
                              "picker-options": {
                                disabledDate: function(time) {
                                  return (
                                    time.getTime() >
                                    new Date(
                                      _vm.filter.endEta + " 23:59:59"
                                    ).getTime()
                                  )
                                }
                              },
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.beginEta,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "beginEta", $$v)
                              },
                              expression: "filter.beginEta"
                            }
                          }),
                          _c("span", { staticStyle: { margin: "5px" } }, [
                            _vm._v(_vm._s(_vm.$t("Pricing.EndDate")))
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "130px" },
                            attrs: {
                              no: "endEta",
                              type: "date",
                              "picker-options": {
                                disabledDate: function(time) {
                                  return (
                                    time.getTime() <
                                    new Date(
                                      _vm.filter.beginEta + " 00:00:00"
                                    ).getTime()
                                  )
                                }
                              },
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.endEta,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "endEta", $$v)
                              },
                              expression: "filter.endEta"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showVia
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            "label-width": "45px",
                            label: _vm.$t("Pricing.Direct")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "directType",
                              filterable: "",
                              "tag-name": "chineseName",
                              "tag-value": "code",
                              "filter-tag-names": ["chineseName", "code"],
                              "static-options": _vm.directTypes,
                              multiple: "",
                              clearable: false,
                              "default-multiple-value": _vm.filter.directTypes
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.directTypes = p.code
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.showSchedule
                ? _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "80px",
                        "label-position": "left",
                        inline: true
                      }
                    },
                    [
                      _vm.needAddon
                        ? _c(
                            "el-checkbox",
                            {
                              attrs: { no: "isAddon" },
                              model: {
                                value: _vm.filter.isAddon,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "isAddon", $$v)
                                },
                                expression: "filter.isAddon"
                              }
                            },
                            [_vm._v("Addon")]
                          )
                        : _vm._e(),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "direct" },
                          model: {
                            value: _vm.filter.direct,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "direct", $$v)
                            },
                            expression: "filter.direct"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Direct")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "frequency1" },
                          model: {
                            value: _vm.filter.frequency1,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "frequency1", $$v)
                            },
                            expression: "filter.frequency1"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Mon")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "frequency2" },
                          model: {
                            value: _vm.filter.frequency2,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "frequency2", $$v)
                            },
                            expression: "filter.frequency2"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Tue")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "frequency3" },
                          model: {
                            value: _vm.filter.frequency3,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "frequency3", $$v)
                            },
                            expression: "filter.frequency3"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Wed")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "frequency4" },
                          model: {
                            value: _vm.filter.frequency4,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "frequency4", $$v)
                            },
                            expression: "filter.frequency4"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Thu")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "frequency5" },
                          model: {
                            value: _vm.filter.frequency5,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "frequency5", $$v)
                            },
                            expression: "filter.frequency5"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Fri")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "frequency6" },
                          model: {
                            value: _vm.filter.frequency6,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "frequency6", $$v)
                            },
                            expression: "filter.frequency6"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Sat")))]
                      ),
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "frequency7" },
                          model: {
                            value: _vm.filter.frequency7,
                            callback: function($$v) {
                              _vm.$set(_vm.filter, "frequency7", $$v)
                            },
                            expression: "filter.frequency7"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Sun")))]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }